import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Loader from "./components/Loader";
import WhatsAppFloat from "./components/WhatsAppFloat";

import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import AgarbattiPage from "./pages/AgarbattiPage";
import DhoopConePage from "./pages/DhoopConePage";
import DhoopStickPage from "./pages/DhoopStickPage";
import Contact from "./pages/Contact";
import OtherProducts from './pages/OtherProducts';


import "./styles/global.css";

function ScrollHandler() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const minLoaderTime = setTimeout(() => {
      setLoading(false);
    }, 2200);

    return () => clearTimeout(minLoaderTime);
  }, []);

  return (
    <Router>
      {loading && <Loader />}

      <div className={`site-content ${loading ? "site-loading" : "site-loaded"}`}>
        <ScrollHandler />
        <Navbar />
        <WhatsAppFloat />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/agarbatti" element={<AgarbattiPage />} />
          <Route path="/products/dhoop-cone" element={<DhoopConePage />} />
          <Route path="/products/dhoop-stick" element={<DhoopStickPage />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/products/other" element={<OtherProducts />} />

          <Route path="/contact" element={<Contact />} />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}